exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-box[data-v-5f346b19],.talent-box[data-v-5f346b19]{padding:0 20px;margin-bottom:20px}.search-item[data-v-5f346b19]{display:inline-block;width:150px;margin-bottom:10px}.search-item-long[data-v-5f346b19]{display:inline-block;width:300px;margin-bottom:10px}.edit-btn[data-v-5f346b19]{margin-left:0;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f346b19&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/talent/talentManage.vue
// module id = 547
// module chunks = 0